import * as React from 'react';
import './PVABadge.css';

interface PVABadgeProps {
    style: string; // Style name, e.g. "Relator"
    badge: string; // Kept for compatibility; used as alt/title text
}

export class PVABadge extends React.Component<PVABadgeProps, {}> {
    constructor(props: PVABadgeProps) {
        super(props);
    }

    private imageSrc() {
        // Map style name to the corresponding SVG in public/images/badges/
        // Example: "Relator" -> "/images/badges/relator icon.svg"
        const styleName = (this.props.style || '').toLowerCase();
        return `/images/badges/${styleName} icon.svg`;
    }

    render() {
        if (!this.props.style) {
            return (
                <span className="fas fa-question-circle pva-badge-placeholder" title="Missing style" />
            );
        }
        const alt = this.props.badge || this.props.style || 'PVA badge';
        return (
            <img className="pva-badge-image" src={this.imageSrc()} alt={`${alt} badge`} title={alt} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVABadge.tsx